import React from 'react';
import ReactDOM from 'react-dom/client';
// Fuentes autoalojadas (sin Google Fonts: RGPD). Solo los pesos que se usan, en latin y latin-ext
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-ext-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-ext-500.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-ext-600.css';
import '@fontsource/poppins/latin-700.css';
import '@fontsource/poppins/latin-ext-700.css';
import '@fontsource/poppins/latin-500-italic.css';
import '@fontsource/poppins/latin-ext-500-italic.css';
import './index.css';
// Reset global: antes se colaba desde Login/Contacto/NotFound; ahora, con las páginas en
// lazy, se carga siempre para que la web se vea igual visites la ruta que visites
import './styles/Reset/reset-global.css';
// Tema azul de marca sobre fondos claros: tokens → base global → compatibilidad provisional
// de las pantallas sin rediseñar (hoy vacía; se puede borrar en el Paso 2)
import './styles/Base/tokens.css';
import './styles/Base/global.css';
import './styles/Base/Boton.css';
import './styles/Base/compat-paso2.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { activarAvisoDeErrores } from './services/errores';


// Avisa a la API de los errores que ocurran en el navegador de los visitantes (solo en producción)
activarAvisoDeErrores();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <App />
  </Router>
);
